import { render, staticRenderFns } from "./confirmProcess.vue?vue&type=template&id=0515bcf8&"
import script from "./confirmProcess.vue?vue&type=script&lang=js&"
export * from "./confirmProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports